<template>
  <div class="form form-invoice">
    <h5>{{ $t("message.contracts.document_packaging") }}</h5>
    <validation
      v-if="document_id != 'new'"
      :action="go_to_error"
      section="packinglist"
      :contractId="contract_details.attis_contract_id"
      :item="document_id"
    />
    <br />
    <div
      class="alert mt-2 alert-success rounded d-flex"
      v-if="is_field_readonly"
    >
      <span style="flex-basis: 50%">
        {{
          $t(
            "message.contracts.signed_message_" +
              this.packagings[0].SignatureType,
          )
        }}
        {{ this.packagings[0].SignDate }}<br />
        {{ this.packagings[0].SignatureName }}
      </span>
    </div>
    <b-table :items="packagings" :fields="core_packaging_fields">
      <template #cell(invoice)="data">
        {{ data.value.display_text }}
      </template>
      <template #cell(products_count)="data">
        {{ data.item.goods.length }}
      </template>
      <template #cell(number)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(action)="data">
        <button
          class="btn btn-link btn-sm p-0 mr-3"
          @click="edit_packaging(data.item)"
        >
          <i class="fa fa-edit"></i>
        </button>
        <button
          class="btn btn-link btn-sm text-danger p-0"
          @click="delete_packaging(data.index)"
          :disabled="is_field_readonly"
        >
          <i class="fa fa-trash"></i>
        </button>
      </template>
    </b-table>
    <button
      id="create-add-new-packing-list-button"
      class="btn btn-outline-success btn-sm"
      @click="create_packging_list()"
    >
      {{ $t("message.add") }}
    </button>
    <b-modal
      id="create_new_packaging"
      centered
      hide-footer
      size="xl"
      :title="$t('message.contracts.documents_packging_list_for_invoice')"
    >
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group required',
          focused.invoice == true ? 'focused' : '',
          $v.new_list.invoice.$error ? 'has-danger' : '',
        ]"
      >
        <v-select
          id="new_invoice"
          @input="invoice_changed"
          :options="invoices"
          label="display_text"
          :class="[
            'form-control',
            typeof new_list.invoice !== 'undefined' &&
            new_list.invoice.DocumentID !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchInvoices"
          v-model="new_list.invoice"
          :placeholder="$t('message.contracts.documents_packaging_invoice')"
          @focus="focused.invoice = true"
          @blur="focused.invoice = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label for="new_invoice" class="form-label-group-label shorter">{{
          $t("message.contracts.documents_packaging_invoice")
        }}</label>
        <label
          v-if="form_error && !$v.new_list.invoice.required"
          class="control-label text-danger d-block"
          >{{ $t("message.errors.required") }}</label
        >
      </span>
      <div class="row">
        <div class="col-md-6">
          <span
            :class="['bmd-form-group mb-1 d-block form-label-group required']"
          >
            <label
              for="gross_weight_quantity"
              :class="[
                'form-label-group-label shorter',
                new_list.gross_weight_quantity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.packaging_brutto_total") }}</label
            >
            <cleave
              id="gross_weight_quantity"
              v-model="new_list.gross_weight_quantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.packaging_brutto_total')"
              autocomplete="off"
              style="cursor: auto"
              :disabled="is_field_readonly"
            ></cleave>
            <label
              v-if="form_error && !$v.new_list.gross_weight_quantity.required"
              class="control-label text-danger d-block"
              >{{ $t("message.errors.required") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="['bmd-form-group mb-1 d-block form-label-group required']"
          >
            <label
              for="net_weight_quantity"
              :class="[
                'form-label-group-label shorter',
                new_list.net_weight_quantity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.packaging_netto_total") }}</label
            >
            <cleave
              id="net_weight_quantity"
              v-model="new_list.net_weight_quantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.packaging_netto_total')"
              autocomplete="off"
              style="cursor: auto"
              :disabled="is_field_readonly"
            ></cleave>
            <label
              v-if="form_error && !$v.new_list.net_weight_quantity.required"
              class="control-label text-danger d-block"
              >{{ $t("message.errors.required") }}</label
            >
          </span>
        </div>
      </div>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group required']">
        <input
          type="text"
          readonly
          id="consignor"
          label="display_text"
          :class="['form-control']"
          v-model="new_list.consignor_name"
          :placeholder="$t('message.contracts.packaging_consignor')"
          :disabled="is_field_readonly"
        />
        <label for="consignor" class="form-label-group-label shorter">{{
          $t("message.contracts.packaging_consignor")
        }}</label>
      </span>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group required']">
        <input
          type="text"
          readonly
          id="consignee"
          label="display_text"
          :class="['form-control']"
          v-model="new_list.consignee_name"
          :placeholder="$t('message.contracts.packaging_consignee')"
          :disabled="is_field_readonly"
        />
        <label for="consignee" class="form-label-group-label shorter">{{
          $t("message.contracts.packaging_consignee")
        }}</label>
      </span>
      <code-value
        :label="$t('message.contracts.DeliveryTermsStringCode')"
        :value_placeholder="$t('message.contracts.DeliveryTermsStringCode')"
        :code_placeholder="$t('message.contracts.DeliveryTermsStringCode_code')"
        type="delivery_term"
        v-model="new_list.delivery_terms"
        :readonly="is_field_readonly"
      ></code-value>
      <div id="products-table">
        <b-tabs pills content-class="mt-3" small>
          <b-tab :title="$t('message.contracts.packaging_product_tab')">
            <b-table :items="new_list.goods" :fields="product_fields">
              <template #cell(action)="data">
                <button
                  class="btn btn-link btn-sm p-0 mr-3"
                  @click="edit_product(data.item, data.index)"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button
                  v-if="!is_field_readonly"
                  class="btn btn-link btn-sm p-0 text-red"
                  @click="delete_product(data.index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </template>
              <template #cell(number)="data">
                {{ data.index + 1 }}
              </template>
            </b-table>
            <button
              v-if="!is_field_readonly"
              id="packing-add-new-product-button"
              class="btn btn-outline-success btn-sm"
              @click="add_product"
            >
              {{ $t("message.add") }}
            </button>
            <div v-if="!add_product && !is_field_readonly" class="form-group">
              <label for="excel-goods-import">{{
                $t("message.contracts.excel_import_gooods_label")
              }}</label>
              <input
                type="file"
                id="excel-goods-import"
                :disabled="files_loading"
                class="form-control"
                @change="importGoodsExcel($event, index)"
              />
            </div>
          </b-tab>

          <b-tab :title="$t('message.contracts.packaging_transport_tab')">
            <b-table :items="new_list.transports" :fields="transport_fields">
              <template #cell(action)="data">
                <button
                  class="btn btn-link btn-sm p-0 mr-3"
                  @click="edit_transport(data.item, data.index)"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button
                  v-if="!is_field_readonly"
                  class="btn btn-link btn-sm p-0 text-red"
                  @click="delete_transport(data.index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </template>
              <template #cell(packaging_transportleading)="data">
                <span v-if="data.value == true">Да</span>
                <span v-else>Нет</span>
              </template>
              <template #cell(packaging_transporttypecode)="data">
                {{ data.value.display_text }}
              </template>
              <template #cell(packaging_transportcountrycode)="data">
                {{ data.value.display_text }}
              </template>
            </b-table>
            <button
              v-if="!is_field_readonly"
              id="pl-add-transport-button"
              class="btn btn-outline-success btn-sm"
              @click="add_transport"
            >
              {{ $t("message.add") }}
            </button>
          </b-tab>
          <b-tab :title="$t('message.contracts.packaging_places_tab')">
            <b-table :items="new_list.places" :fields="places_fields">
              <template #cell(action)="data">
                <button
                  class="btn btn-link btn-sm p-0 mr-3"
                  @click="edit_list_place(data.item, data.index)"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button
                  v-if="!is_field_readonly"
                  class="btn btn-link btn-sm p-0 text-red"
                  @click="delete_list_place(data.index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </template>
              <template #cell(packaging_packagingtypecode)="data">
                {{ data.value.display_text }}
              </template>
              <template #cell(number)="data">
                {{ data.index + 1 }}
              </template>
            </b-table>
            <button
              v-if="!is_field_readonly"
              id="add-new-overall-places-button"
              class="btn btn-outline-success btn-sm"
              @click="add_list_place()"
            >
              {{ $t("message.add") }}
            </button>
          </b-tab>
        </b-tabs>
      </div>
      <hr />
      <button
        v-if="!is_field_readonly"
        id="save-create-new-packaging-button"
        class="btn btn-success"
        @click="save_create_new_packaging"
      >
        {{ $t("message.save") }}
      </button>
    </b-modal>
    <b-modal
      id="edit_packaging_list"
      centered
      hide-footer
      size="xl"
      :title="$t('message.contracts.documents_packging_list_for_invoice')"
    >
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group required',
          focused.invoice == true ? 'focused' : '',
          $v.new_list.invoice.$error ? 'has-danger' : '',
        ]"
      >
        <v-select
          id="new_invoice"
          @input="invoice_changed"
          :options="invoices"
          label="display_text"
          :class="[
            'form-control',
            typeof new_list.invoice !== 'undefined' &&
            new_list.invoice.DocumentID !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchInvoices"
          v-model="new_list.invoice"
          :placeholder="$t('message.contracts.documents_packaging_invoice')"
          @focus="focused.invoice = true"
          @blur="focused.invoice = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label for="new_invoice" class="form-label-group-label shorter">{{
          $t("message.contracts.documents_packaging_invoice")
        }}</label>
        <label
          v-if="form_error && !$v.new_list.invoice.required"
          class="control-label text-danger d-block"
          >{{ $t("message.errors.required") }}</label
        >
      </span>
      <div class="row">
        <div class="col-md-6">
          <span
            :class="['bmd-form-group mb-1 d-block form-label-group required']"
          >
            <label
              for="gross_weight_quantity"
              :class="[
                'form-label-group-label shorter',
                new_list.gross_weight_quantity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.packaging_brutto_total") }}</label
            >
            <cleave
              id="gross_weight_quantity"
              v-model="new_list.gross_weight_quantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.packaging_brutto_total')"
              autocomplete="off"
              style="cursor: auto"
              :disabled="is_field_readonly"
            ></cleave>
            <label
              v-if="form_error && !$v.new_list.gross_weight_quantity.required"
              class="control-label text-danger d-block"
              >{{ $t("message.errors.required") }}</label
            >
          </span>
        </div>
        <div class="col-md-6">
          <span
            :class="['bmd-form-group mb-1 d-block form-label-group required']"
          >
            <label
              for="net_weight_quantity"
              :class="[
                'form-label-group-label shorter',
                new_list.net_weight_quantity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.packaging_netto_total") }}</label
            >
            <cleave
              id="net_weight_quantity"
              v-model="new_list.net_weight_quantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.packaging_netto_total')"
              autocomplete="off"
              style="cursor: auto"
              :disabled="is_field_readonly"
            ></cleave>
            <label
              v-if="form_error && !$v.new_list.net_weight_quantity.required"
              class="control-label text-danger d-block"
              >{{ $t("message.errors.required") }}</label
            >
          </span>
        </div>
      </div>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group required']">
        <input
          type="text"
          readonly
          id="consignor"
          label="display_text"
          :class="['form-control']"
          v-model="new_list.consignor_name"
          :placeholder="$t('message.contracts.packaging_consignor')"
          :disabled="is_field_readonly"
        />
        <label for="consignor" class="form-label-group-label shorter">{{
          $t("message.contracts.packaging_consignor")
        }}</label>
      </span>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group required']">
        <input
          type="text"
          readonly
          id="consignee"
          label="display_text"
          :class="['form-control']"
          v-model="new_list.consignee_name"
          :placeholder="$t('message.contracts.packaging_consignee')"
          :disabled="is_field_readonly"
        />
        <label for="consignee" class="form-label-group-label shorter">{{
          $t("message.contracts.packaging_consignee")
        }}</label>
      </span>
      <code-value
        :label="$t('message.contracts.DeliveryTermsStringCode')"
        :value_placeholder="$t('message.contracts.DeliveryTermsStringCode')"
        :code_placeholder="$t('message.contracts.DeliveryTermsStringCode_code')"
        type="delivery_term"
        v-model="new_list.delivery_terms"
        :readonly="is_field_readonly"
      ></code-value>
      <b-tabs pills content-class="mt-3" small>
        <b-tab :title="$t('message.contracts.packaging_product_tab')">
          <b-table :items="new_list.goods" :fields="product_fields">
            <template #cell(action)="data">
              <button
                class="btn btn-link btn-sm p-0 mr-3"
                @click="edit_product(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                v-if="!is_field_readonly"
                class="btn btn-link btn-sm p-0 text-red"
                @click="delete_product(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
            <template #cell(number)="data">
              {{ data.index + 1 }}
            </template>
          </b-table>
          <button
            v-if="!is_field_readonly"
            class="btn btn-outline-success btn-sm"
            @click="add_product"
          >
            {{ $t("message.add") }}
          </button>
        </b-tab>
        <b-tab :title="$t('message.contracts.packaging_transport_tab')">
          <b-table :items="new_list.transports" :fields="transport_fields">
            <template #cell(action)="data">
              <button
                class="btn btn-link btn-sm p-0 mr-3"
                @click="edit_transport(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                v-if="!is_field_readonly"
                class="btn btn-link btn-sm p-0 text-red"
                @click="delete_transport(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
            <template #cell(packaging_transportleading)="data">
              <span v-if="data.value == true">Да</span>
              <span v-else>Нет</span>
            </template>
            <template #cell(packaging_transporttypecode)="data">
              {{ data.value.display_text }}
            </template>
            <template #cell(packaging_transportcountrycode)="data">
              {{ data.value.display_text }}
            </template>
          </b-table>
          <button
            v-if="!is_field_readonly"
            id="pl-add-transport-button"
            class="btn btn-outline-success btn-sm"
            @click="add_transport"
          >
            {{ $t("message.add") }}
          </button>
        </b-tab>
        <b-tab :title="$t('message.contracts.packaging_places_tab')">
          <b-table :items="new_list.places" :fields="places_fields">
            <template #cell(action)="data">
              <button
                class="btn btn-link btn-sm p-0 mr-3"
                @click="edit_list_place(data.item, data.index)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                v-if="!is_field_readonly"
                class="btn btn-link btn-sm p-0 text-red"
                @click="delete_list_place(data.index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
            <template #cell(packaging_packagingtypecode)="data">
              {{ data.value.display_text }}
            </template>
            <template #cell(number)="data">
              {{ data.index + 1 }}
            </template>
          </b-table>
          <button
            v-if="!is_field_readonly"
            class="btn btn-outline-success btn-sm"
            @click="add_list_place()"
          >
            {{ $t("message.add") }}
          </button>
        </b-tab>
      </b-tabs>
      <hr />
      <button
        v-if="!is_field_readonly"
        class="btn btn-success"
        @click="save_edit_packaging_list"
      >
        {{ $t("message.save") }}
      </button>
    </b-modal>
    <b-modal
      id="edit_product"
      centered
      hide-footer
      size="lg"
      :title="$t('message.contracts.packaging_products_modal')"
    >
      <translatable>
        <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
          <textarea
            type="text"
            id="product_description"
            label="display_text"
            :class="['form-control']"
            v-model="current_product.goodsdescription"
            :placeholder="$t('message.contracts.packaging_goodsdescription')"
            :disabled="is_field_readonly"
          ></textarea>
          <label
            for="product_description"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.packaging_goodsdescription") }}</label
          >
        </span>
      </translatable>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="goodsquantity"
          :class="[
            'form-label-group-label shorter',
            current_product.goodsquantity != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packaging_goodsquantity") }}</label
        >
        <cleave
          id="goodsquantity"
          v-model="current_product.goodsquantity"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_goodsquantity')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="placegoodsquantity"
          :class="[
            'form-label-group-label shorter',
            current_product.placegoodsquantity != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packaging_placegoodsquantity") }}</label
        >
        <cleave
          id="placegoodsquantity"
          v-model="current_product.placegoodsquantity"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_placegoodsquantity')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.measureunitqualifiername == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="measureunitqualifiername"
          @input="product_measure_changed"
          :options="measures"
          label="display_text"
          :class="[
            'form-control',
            typeof current_product.measureunitqualifier !== 'undefined' &&
            current_product.measureunitqualifier.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchMeasures"
          v-model="current_product.measureunitqualifier"
          :placeholder="
            $t('message.contracts.packaging_measureunitqualifiername')
          "
          @focus="focused.measureunitqualifiername = true"
          @blur="focused.measureunitqualifiername = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="measureunitqualifiername"
          class="form-label-group-label shorter"
          >{{
            $t("message.contracts.packaging_measureunitqualifiername")
          }}</label
        >
      </span>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
            <label
              for="gross_weight_quantity_product"
              :class="[
                'form-label-group-label shorter',
                current_product.grossweightquantity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.packaging_brutto") }}</label
            >
            <cleave
              id="gross_weight_quantity_product"
              @input="recalculate_total_weights"
              v-model="current_product.grossweightquantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.packaging_brutto')"
              autocomplete="off"
              style="cursor: auto"
              :disabled="is_field_readonly"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
            <label
              for="net_weight_quantity_product"
              :class="[
                'form-label-group-label shorter',
                current_product.netweightquantity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.packaging_netto") }}</label
            >
            <cleave
              id="net_weight_quantity_product"
              @input="recalculate_total_weights"
              v-model="current_product.netweightquantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.packaging_netto')"
              autocomplete="off"
              style="cursor: auto"
              :disabled="is_field_readonly"
            ></cleave>
          </span>
        </div>
      </div>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
        <textarea
          maxlength="255"
          type="text"
          id="product_dimensions"
          label="display_text"
          :class="['form-control']"
          v-model="current_product.dimensions"
          :placeholder="$t('message.contracts.packaging_dimensions')"
          :disabled="is_field_readonly"
        ></textarea>
        <label
          for="product_dimensions"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_dimensions") }}</label
        >
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="goodsvolume"
          :class="[
            'form-label-group-label shorter',
            current_product.goodsvolume != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packaging_goodsvolume") }}</label
        >
        <cleave
          id="goodsvolume"
          v-model="current_product.goodsvolume"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_goodsvolume')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.volumeunitqualifiername == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="volumeunitqualifiername"
          @input="product_volume_measure_changed"
          :options="measures"
          label="display_text"
          :class="[
            'form-control',
            typeof current_product.volumeunitqualifier !== 'undefined' &&
            current_product.volumeunitqualifier.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchMeasures"
          v-model="current_product.volumeunitqualifier"
          :placeholder="
            $t('message.contracts.packaging_volumeunitqualifiername')
          "
          @focus="focused.volumeunitqualifiername = true"
          @blur="focused.volumeunitqualifiername = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="volumeunitqualifiername"
          class="form-label-group-label shorter"
          >{{
            $t("message.contracts.packaging_volumeunitqualifiername")
          }}</label
        >
      </span>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
        <input
          type="text"
          id="goodmarking"
          label="display_text"
          :class="['form-control']"
          v-model="current_product.goodmarking"
          :placeholder="$t('message.contracts.packaging_goodmarking')"
          :disabled="is_field_readonly"
        />
        <label for="goodmarking" class="form-label-group-label shorter">{{
          $t("message.contracts.packaging_goodmarking")
        }}</label>
      </span>
      <b-table :items="current_product.packagings" :fields="packaging_fields">
        <template #cell(action)="data">
          <button
            class="btn btn-link btn-sm p-0 mr-3"
            @click="edit_product_place(data.item, data.index)"
          >
            <i class="fa fa-edit"></i>
          </button>
          <button
            v-if="!is_field_readonly"
            class="btn btn-link text-danger btn-sm p-0"
            @click="delete_product_place(data.item, data.index)"
          >
            <i class="fa fa-trash"></i>
          </button>
        </template>
        <template #cell(packaging_packagingtypecode)="data">
          {{ data.value.display_text }}
        </template>
      </b-table>
      <button
        v-if="!is_field_readonly"
        class="btn btn-sm btn-outline-success"
        @click="add_product_packaging"
      >
        {{ $t("message.add") }}
      </button>
      <hr />
      <button
        v-if="!is_field_readonly"
        @click="save_edit_product"
        class="btn btn-success ml-auto"
      >
        {{ $t("message.save") }}
      </button>
    </b-modal>
    <b-modal
      id="add_product"
      centered
      hide-footer
      size="lg"
      :title="$t('message.contracts.packaging_products_modal')"
    >
      <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
        <textarea
          type="text"
          id="product_description"
          label="display_text"
          :class="['form-control']"
          v-model="current_product.goodsdescription"
          :placeholder="$t('message.contracts.packaging_goodsdescription')"
          :disabled="is_field_readonly"
        ></textarea>
        <label
          for="product_description"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_goodsdescription") }}</label
        >
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="goodsquantity"
          :class="[
            'form-label-group-label shorter',
            current_product.goodsquantity != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packaging_goodsquantity") }}</label
        >
        <cleave
          id="goodsquantity"
          v-model="current_product.goodsquantity"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_goodsquantity')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="placegoodsquantity"
          :class="[
            'form-label-group-label shorter',
            current_product.placegoodsquantity != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packaging_placegoodsquantity") }}</label
        >
        <cleave
          id="placegoodsquantity"
          v-model="current_product.placegoodsquantity"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_placegoodsquantity')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.measureunitqualifiername == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="measureunitqualifiername"
          @input="product_measure_changed"
          :options="measures"
          label="display_text"
          :class="[
            'form-control',
            typeof current_product.measureunitqualifier !== 'undefined' &&
            current_product.measureunitqualifier.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchMeasures"
          v-model="current_product.measureunitqualifier"
          :placeholder="
            $t('message.contracts.packaging_measureunitqualifiername')
          "
          @focus="focused.measureunitqualifiername = true"
          @blur="focused.measureunitqualifiername = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="measureunitqualifiername"
          class="form-label-group-label shorter"
          >{{
            $t("message.contracts.packaging_measureunitqualifiername")
          }}</label
        >
      </span>
      <div class="row">
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
            <label
              for="gross_weight_quantity_product"
              :class="[
                'form-label-group-label shorter',
                current_product.grossweightquantity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.packaging_brutto") }}</label
            >
            <cleave
              id="gross_weight_quantity_product"
              @input="recalculate_total_weights"
              v-model="current_product.grossweightquantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.packaging_brutto')"
              autocomplete="off"
              style="cursor: auto"
              :disabled="is_field_readonly"
            ></cleave>
          </span>
        </div>
        <div class="col-md-6">
          <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
            <label
              for="net_weight_quantity_product"
              :class="[
                'form-label-group-label shorter',
                current_product.netweightquantity != '' ? 'high' : '',
              ]"
              >{{ $t("message.contracts.packaging_netto") }}</label
            >
            <cleave
              id="net_weight_quantity_product"
              @input="recalculate_total_weights"
              v-model="current_product.netweightquantity"
              :options="cleaveWeight"
              class="form-control"
              :placeholder="$t('message.contracts.packaging_netto')"
              autocomplete="off"
              style="cursor: auto"
              :disabled="is_field_readonly"
            ></cleave>
          </span>
        </div>
      </div>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
        <textarea
          maxlength="255"
          type="text"
          id="product_dimensions"
          label="display_text"
          :class="['form-control']"
          v-model="current_product.dimensions"
          :placeholder="$t('message.contracts.packaging_dimensions')"
          :disabled="is_field_readonly"
        ></textarea>
        <label
          for="product_dimensions"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_dimensions") }}</label
        >
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="goodsvolume"
          :class="[
            'form-label-group-label shorter',
            current_product.goodsvolume != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packaging_goodsvolume") }}</label
        >
        <cleave
          id="goodsvolume"
          v-model="current_product.goodsvolume"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_goodsvolume')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.volumeunitqualifiername == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="volumeunitqualifiername"
          @input="product_volume_measure_changed"
          :options="measures"
          label="display_text"
          :class="[
            'form-control',
            typeof current_product.volumeunitqualifier !== 'undefined' &&
            current_product.volumeunitqualifier.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchMeasures"
          v-model="current_product.volumeunitqualifier"
          :placeholder="
            $t('message.contracts.packaging_volumeunitqualifiername')
          "
          @focus="focused.volumeunitqualifiername = true"
          @blur="focused.volumeunitqualifiername = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="volumeunitqualifiername"
          class="form-label-group-label shorter"
          >{{
            $t("message.contracts.packaging_volumeunitqualifiername")
          }}</label
        >
      </span>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
        <input
          type="text"
          id="goodmarking"
          label="display_text"
          :class="['form-control']"
          v-model="current_product.goodmarking"
          :placeholder="$t('message.contracts.packaging_goodmarking')"
          :disabled="is_field_readonly"
        />
        <label for="goodmarking" class="form-label-group-label shorter">{{
          $t("message.contracts.packaging_goodmarking")
        }}</label>
      </span>
      <b-table :items="current_product.packagings" :fields="packaging_fields">
        <template #cell(action)="data">
          <button
            class="btn btn-link btn-sm p-0 mr-3"
            @click="edit_product_place(data.item, data.index)"
          >
            <i class="fa fa-edit"></i>
          </button>
          <button
            v-if="!is_field_readonly"
            class="btn btn-link text-danger btn-sm p-0"
            @click="delete_product_place(data.item, data.index)"
          >
            <i class="fa fa-trash"></i>
          </button>
        </template>
        <template #cell(packaging_packagingtypecode)="data">
          {{ data.value.display_text }}
        </template>
      </b-table>
      <button
        v-if="!is_field_readonly"
        id="add-new-packaging-place-button"
        class="btn btn-sm btn-outline-success"
        @click="add_product_packaging"
      >
        {{ $t("message.add") }}
      </button>
      <hr />
      <button
        v-if="!is_field_readonly"
        id="save-packaging-product-button"
        @click="save_new_product"
        class="btn btn-success ml-auto"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>
    <b-modal
      id="product_place_edit_modal"
      centered
      hide-footer
      size="sm"
      :title="$t('message.contracts.packaging_prouct_packaging_modal_title')"
    >
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="placegoodsquantity"
          :class="['form-label-group-label shorter high']"
          >{{ $t("message.contracts.packaging_number_pp") }}</label
        >
        <input
          type="text"
          readonly
          class="form-control"
          :value="current_product_packaging_index"
          :disabled="is_field_readonly"
        />
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="packging_placescount"
          :class="[
            'form-label-group-label shorter',
            new_product_packaging.packging_placescount != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packging_placescount") }}</label
        >
        <cleave
          id="packging_placescount"
          v-model="current_product_packaging.packging_placescount"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packging_placescount')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <translatable>
        <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
          <textarea
            maxlength="255"
            type="text"
            id="packaging_placesdescription"
            label="display_text"
            :class="['form-control']"
            v-model="current_product_packaging.packaging_placesdescription"
            :placeholder="$t('message.contracts.packaging_placesdescription')"
            :disabled="is_field_readonly"
          ></textarea>
          <label
            for="packaging_placesdescription"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.packaging_placesdescription") }}</label
          >
        </span>
      </translatable>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.new_product_packaging == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="packaging_packagingtypecode"
          :options="type_packagings"
          label="display_text"
          :class="[
            'form-control',
            typeof current_product_packaging.packaging_packagingtypecode !==
              'undefined' &&
            current_product_packaging.packaging_packagingtypecode.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchPackagings"
          v-model="current_product_packaging.packaging_packagingtypecode"
          :placeholder="$t('message.contracts.packaging_packagingtypecode')"
          @focus="focused.new_product_packaging = true"
          @blur="focused.new_product_packaging = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="packaging_packagingtypecode"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_packagingtypecode") }}</label
        >
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="packaging_partialplacescount"
          :class="[
            'form-label-group-label shorter',
            current_product_packaging.packaging_partialplacescount != ''
              ? 'high'
              : '',
          ]"
          >{{ $t("message.contracts.packaging_partialplacescount") }}</label
        >
        <cleave
          id="packaging_partialplacescount"
          v-model="current_product_packaging.packaging_partialplacescount"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_partialplacescount')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <button
        v-if="!is_field_readonly"
        class="btn btn-success"
        @click="save_packaging_to_product"
      >
        {{ $t("message.save") }}
      </button>
    </b-modal>
    <b-modal
      id="product_place_add_modal"
      centered
      hide-footer
      size="sm"
      :title="$t('message.contracts.packaging_prouct_packaging_modal_title')"
    >
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="placegoodsquantity"
          :class="['form-label-group-label shorter high']"
          >{{ $t("message.contracts.packaging_number_pp") }}</label
        >
        <input
          type="text"
          readonly
          class="form-control"
          :value="new_product_packaging_number"
          :disabled="is_field_readonly"
        />
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="packging_placescount"
          :class="[
            'form-label-group-label shorter',
            new_product_packaging.packging_placescount != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packging_placescount") }}</label
        >
        <cleave
          id="packging_placescount"
          v-model="new_product_packaging.packging_placescount"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packging_placescount')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
        <textarea
          maxlength="255"
          type="text"
          id="packaging_placesdescription"
          label="display_text"
          :class="['form-control']"
          v-model="new_product_packaging.packaging_placesdescription"
          :placeholder="$t('message.contracts.packaging_placesdescription')"
          :disabled="is_field_readonly"
        ></textarea>
        <label
          for="packaging_placesdescription"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_placesdescription") }}</label
        >
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.new_product_packaging == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="packaging_packagingtypecode"
          :options="type_packagings"
          label="display_text"
          :class="[
            'form-control',
            typeof new_product_packaging.packaging_packagingtypecode !==
              'undefined' &&
            new_product_packaging.packaging_packagingtypecode.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchPackagings"
          v-model="new_product_packaging.packaging_packagingtypecode"
          :placeholder="$t('message.contracts.packaging_packagingtypecode')"
          @focus="focused.new_product_packaging = true"
          @blur="focused.new_product_packaging = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="packaging_packagingtypecode"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_packagingtypecode") }}</label
        >
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="packaging_partialplacescount"
          :class="[
            'form-label-group-label shorter',
            new_product_packaging.packaging_partialplacescount != ''
              ? 'high'
              : '',
          ]"
          >{{ $t("message.contracts.packaging_partialplacescount") }}</label
        >
        <cleave
          id="packaging_partialplacescount"
          v-model="new_product_packaging.packaging_partialplacescount"
          :options="cleaveWeight"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_partialplacescount')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <button
        id="packaging-add-places-to-product-button"
        class="btn btn-success"
        @click="add_packaging_to_product"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>
    <b-modal
      centered
      hide-footer
      size="sm"
      :title="$t('message.contracts.packaging_list_transport_tab')"
      id="transport_modal_add"
    >
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="placegoodsquantity"
          :class="['form-label-group-label shorter high']"
          >{{ $t("message.contracts.packaging_number_pp") }}</label
        >
        <input
          type="text"
          readonly
          class="form-control"
          :value="new_product_transport_number"
          :disabled="is_field_readonly"
        />
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="packaging_transport_number"
          :class="[
            'form-label-group-label shorter',
            new_product_transport.packaging_transport_number != ''
              ? 'high'
              : '',
          ]"
          >{{ $t("message.contracts.packaging_transport_number") }}</label
        >
        <input
          type="text"
          id="packaging_transport_number"
          v-model="new_product_transport.packaging_transport_number"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_transport_number')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        />
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.new_product_transport == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="packaging_transporttypecode"
          :options="transporttypes"
          label="display_text"
          :class="[
            'form-control',
            typeof new_product_transport.packaging_transporttypecode !==
              'undefined' &&
            new_product_transport.packaging_transporttypecode.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchTransporttypes"
          v-model="new_product_transport.packaging_transporttypecode"
          :placeholder="$t('message.contracts.packaging_transporttypecode')"
          @focus="focused.new_product_transport = true"
          @blur="focused.new_product_transport = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="packaging_transporttypecode"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_transporttypecode") }}</label
        >
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.new_product_transport_country == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="packaging_transportcountrycode"
          :options="countries"
          label="display_text"
          :class="[
            'form-control',
            typeof new_product_transport.packaging_transportcountrycode !==
              'undefined' &&
            new_product_transport.packaging_transportcountrycode.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchCountries"
          v-model="new_product_transport.packaging_transportcountrycode"
          :placeholder="$t('message.contracts.packaging_transportcountrycode')"
          @focus="focused.new_product_transport_country = true"
          @blur="focused.new_product_transport_country = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="packaging_transportcountrycode"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_transportcountrycode") }}</label
        >
      </span>
      <div
        id="lead-vehichle-toggle-button"
        class="togglebutton other mt-md-3 form-label-group"
      >
        <label
          for="packaging_transportcountrycode"
          class="form-label-group-lab23el shorter"
          >{{ $t("message.contracts.packaging_transportleading") }}</label
        ><br />
        <label class="control-label-sm">
          <!--<span>{{$t('message.contracts.type')}}</span><br><br>-->
          <input
            type="checkbox"
            v-model="new_product_transport.packaging_transportleading"
            :disabled="is_field_readonly"
          />
          <span class="toggle"></span>
          <span class="choise_2">{{ $t("message.yes") }}</span>
          <span class="choise_1">{{ $t("message.no") }}</span>
        </label>
      </div>

      <button
        v-if="!is_field_readonly"
        id="add-pl-vehicle-save-button"
        class="btn btn-success"
        @click="add_transport_save"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>
    <b-modal
      centered
      hide-footer
      size="sm"
      :title="$t('message.contracts.packaging_list_transport_tab')"
      id="transport_modal_edit"
    >
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="placegoodsquantity"
          :class="['form-label-group-label shorter high']"
          >{{ $t("message.contracts.packaging_number_pp") }}</label
        >
        <input
          type="text"
          readonly
          class="form-control"
          :value="current_transport_index + 1"
          :disabled="is_field_readonly"
        />
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="packaging_transport_number"
          :class="[
            'form-label-group-label shorter',
            current_transport.packaging_transport_number != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packaging_transport_number") }}</label
        >
        <input
          type="text"
          id="packaging_transport_number"
          v-model="current_transport.packaging_transport_number"
          class="form-control"
          :placeholder="$t('message.contracts.packaging_transport_number')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        />
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.new_product_transport == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="packaging_transporttypecode"
          :options="transporttypes"
          label="display_text"
          :class="[
            'form-control',
            typeof current_transport.packaging_transporttypecode !==
              'undefined' &&
            current_transport.packaging_transporttypecode.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchTransporttypes"
          v-model="current_transport.packaging_transporttypecode"
          :placeholder="$t('message.contracts.packaging_transporttypecode')"
          @focus="focused.new_product_transport = true"
          @blur="focused.new_product_transport = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="packaging_transporttypecode"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_transporttypecode") }}</label
        >
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.new_product_transport_country == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="packaging_transportcountrycode"
          :options="countries"
          label="display_text"
          :class="[
            'form-control',
            typeof current_transport.packaging_transportcountrycode !==
              'undefined' &&
            current_transport.packaging_transportcountrycode.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchCountries"
          v-model="current_transport.packaging_transportcountrycode"
          :placeholder="$t('message.contracts.packaging_transportcountrycode')"
          @focus="focused.new_product_transport_country = true"
          @blur="focused.new_product_transport_country = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="packaging_transportcountrycode"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_transportcountrycode") }}</label
        >
      </span>
      <div class="togglebutton other mt-md-3 form-label-group">
        <label
          for="packaging_transportcountrycode"
          class="form-label-group-lab23el shorter"
          >{{ $t("message.contracts.packaging_transportleading") }}</label
        ><br />
        <label class="control-label-sm">
          <!--<span>{{$t('message.contracts.type')}}</span><br><br>-->
          <input
            type="checkbox"
            v-model="current_transport.packaging_transportleading"
            :disabled="is_field_readonly"
          />
          <span class="toggle"></span>
          <span class="choise_2">{{ $t("message.yes") }}</span>
          <span class="choise_1">{{ $t("message.no") }}</span>
        </label>
      </div>

      <button
        v-if="!is_field_readonly"
        class="btn btn-success"
        @click="edit_transport_save"
      >
        {{ $t("message.save") }}
      </button>
    </b-modal>

    <b-modal
      centered
      hide-footer
      size="sm"
      :title="$t('message.contracts.packaging_list_places_modal')"
      id="list_places_modal_add"
    >
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="placegoodsquantity"
          :class="['form-label-group-label shorter high']"
          >{{ $t("message.contracts.packaging_number_pp") }}</label
        >
        <input
          type="text"
          readonly
          class="form-control"
          :value="new_list_place_number"
          :disabled="is_field_readonly"
        />
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="packaging_transport_number"
          :class="[
            'form-label-group-label shorter',
            new_list_place.packging_placescount != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packging_placescount") }}</label
        >
        <cleave
          type="text"
          :options="cleaveWeight"
          id="packaging_transport_number"
          v-model="new_list_place.packging_placescount"
          class="form-control"
          :placeholder="$t('message.contracts.packging_placescount')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.new_list_place == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="list_packaging_packagingtypecode"
          :options="type_packagings"
          label="display_text"
          :class="[
            'form-control',
            typeof new_list_place.packaging_packagingtypecode !== 'undefined' &&
            new_list_place.packaging_packagingtypecode.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchPackagings"
          v-model="new_list_place.packaging_packagingtypecode"
          :placeholder="$t('message.contracts.packaging_packagingtypecode')"
          @focus="focused.new_list_place = true"
          @blur="focused.new_list_place = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="list_packaging_packagingtypecode"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_packagingtypecode") }}</label
        >
      </span>
      <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
        <textarea
          maxlength="255"
          type="text"
          id="new_list_placepackaging_placesdescription"
          label="display_text"
          :class="['form-control']"
          v-model="new_list_place.packaging_placesdescription"
          :placeholder="$t('message.contracts.packaging_placesdescription')"
          :disabled="is_field_readonly"
        ></textarea>
        <label
          for="new_list_placepackaging_placesdescription"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_placesdescription") }}</label
        >
      </span>

      <button
        v-if="!is_field_readonly"
        id="overall-places-save-button"
        class="btn btn-success"
        @click="add_new_list_place_save"
      >
        {{ $t("message.add") }}
      </button>
    </b-modal>
    <b-modal
      centered
      hide-footer
      size="sm"
      :title="$t('message.contracts.packaging_list_places_modal')"
      id="list_places_modal_edit"
    >
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="placegoodsquantity"
          :class="['form-label-group-label shorter high']"
          >{{ $t("message.contracts.packaging_number_pp") }}</label
        >
        <input
          type="text"
          readonly
          class="form-control"
          :value="new_list_place_index + 1"
          :disabled="is_field_readonly"
        />
      </span>
      <span :class="['bmd-form-group mb-1 d-block form-label-group ']">
        <label
          for="packaging_transport_number"
          :class="[
            'form-label-group-label shorter',
            new_list_place.packging_placescount != '' ? 'high' : '',
          ]"
          >{{ $t("message.contracts.packging_placescount") }}</label
        >
        <cleave
          type="text"
          :options="cleaveWeight"
          id="packaging_transport_number"
          v-model="new_list_place.packging_placescount"
          class="form-control"
          :placeholder="$t('message.contracts.packging_placescount')"
          autocomplete="off"
          style="cursor: auto"
          :disabled="is_field_readonly"
        ></cleave>
      </span>
      <span
        :class="[
          'bmd-form-group mb-2 mt-2 d-block form-label-group ',
          focused.new_list_place == true ? 'focused' : '',
        ]"
      >
        <v-select
          id="list_packaging_packagingtypecode"
          :options="type_packagings"
          label="display_text"
          :class="[
            'form-control',
            typeof new_list_place.packaging_packagingtypecode !== 'undefined' &&
            new_list_place.packaging_packagingtypecode.value !== ''
              ? 'vs--selected'
              : '',
          ]"
          @search="fetchPackagings"
          v-model="new_list_place.packaging_packagingtypecode"
          :placeholder="$t('message.contracts.packaging_packagingtypecode')"
          @focus="focused.new_list_place = true"
          @blur="focused.new_list_place = false"
          :disabled="is_field_readonly"
        >
        </v-select>
        <label
          for="list_packaging_packagingtypecode"
          class="form-label-group-label shorter"
          >{{ $t("message.contracts.packaging_packagingtypecode") }}</label
        >
      </span>
      <translatable>
        <span :class="['bmd-form-group mb-1 d-block  form-label-group ']">
          <textarea
            maxlength="255"
            type="text"
            id="new_list_placepackaging_placesdescription"
            label="display_text"
            :class="['form-control']"
            v-model="new_list_place.packaging_placesdescription"
            :placeholder="$t('message.contracts.packaging_placesdescription')"
            :disabled="is_field_readonly"
          ></textarea>
          <label
            for="new_list_placepackaging_placesdescription"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.packaging_placesdescription") }}</label
          >
        </span>
      </translatable>

      <button
        v-if="!is_field_readonly"
        class="btn btn-success"
        @click="edit_new_list_place_save"
      >
        {{ $t("message.save") }}
      </button>
    </b-modal>
    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px;position: static; margin-top: 20px;"
    >
      <div class="dropdown">
        <button
          v-if="!is_field_readonly"
          class="btn btn-outline-success btn-sm dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :disabled="buttons_loading"
        >
          {{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}&nbsp;&nbsp;
          <div
            class="loading loading-button"
            v-if="loading"
            style="
              border-top-width: 2px;
              border-top-color: #4caf50;
              top: 30px;
              right: -93px;
            "
          ></div>
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a
            id="create-packing-list-button"
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(false)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create"
                  : "message.contracts.document_save",
              )
            }}</a
          >
          <a
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(true)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create_validate"
                  : "message.contracts.document_save_validate",
              )
            }}</a
          >
          <a
            class="dropdown-item"
            style="color: #4caf50"
            v-if="!is_new"
            @click="submit_and_sign_dialog()"
            :disabled="buttons_loading"
            >{{ $t("message.contracts.submit_and_sign_button") }}</a
          >
        </div>
      </div>
      <!--<button class="btn btn-success float-left" @click="saveDocument(false)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button>
            <button class="btn btn-success float-left" @click="saveDocument(true)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create_validate':'message.contracts.document_save_validate')}}</button> -->
      <!-- <button class="btn btn-info float-right" @click="exportEfreight()">e-Freight</button> -->
    </div>
    <b-modal
      id="modal-select-ecp-type-packing-list"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
export default {
  name: "form-packaging",
  props: ["goods", "contract_details", "document_id", "document", "is_new"],
  data() {
    return {
      files_loading: false,
      show_code_sign_type: false,
      sign_with_code_code: "",
      invoice_id: -1,
      buttons_loading: false,
      measures: [],
      packagings: [],
      invoices: [],
      new_list: {
        invoice: {
          DocumentID: "",
          product: [],
        },
        gross_weight_quantity: "",
        net_weight_quantity: "",
        consignor: {},
        consignor_name: "",
        consignee: {},
        consignee_name: "",
        delivery_terms: {},
        goods: [],
        transports: [],
        places: [],
      },

      current_product: {},
      new_product: {},
      cmrs: [],
      current_transport_index: 0,

      form_error: false,
      focused: {
        invoice: false,
        measureunitqualifiername: false,
        volumeunitqualifiername: false,
        new_product_packaging: false,
        new_product_transport: false,
        new_list_place: false,
      },

      cleaveWeight: {
        numeral: true,
        numeralPositiveOnly: true,
        blocks: [20],
        numeralDecimalScale: 2,
      },

      packagins: [],

      new_product_packaging: {
        packging_placescount: "",
        packaging_placesdescription: "",
        packaging_packagingtypecode: { value: "", display_text: "" },
        packaging_partialplacescount: "",
      },
      new_product_transport: {
        packaging_transport_number: "",
        packaging_transporttypecode: { value: "", display_text: "" },
        packaging_transportcountrycode: { value: "", display_text: "" },
        packaging_transportleading: false,
      },
      new_list_place: {
        packging_placescount: "",
        packaging_placesdescription: "",
        packaging_packagingtypecode: { value: "", display_text: "" },
        packaging_partialplacescount: "",
      },
      new_list_place_index: -1,
      current_transport: {},
      countries: [],
      transporttypes: [],
      current_product_packaging: {},
      current_product_packaging_index: -1,
      type_packagings: [],
      core_packaging_fields: [
        {
          key: "number",
          label: this.$t("message.contracts.documents_packaging_number"),
          sortable: false,
        },
        {
          key: "invoice",
          label: this.$t("message.contracts.documents_packaging_invoice"),
          sortable: false,
        },
        {
          key: "products_count",
          label: this.$t(
            "message.contracts.documents_packaging_products_count",
          ),
          sortable: false,
        },
        {
          key: "action",
          label: "",
        },
      ],
      product_fields: [
        {
          key: "number",
          label: this.$t("message.contracts.packaging_number_pp"),
        },
        {
          key: "goodsdescription",
          label: this.$t("message.contracts.packaging_goodsdescription"),
        },
        {
          key: "goodsquantity",
          label: this.$t("message.contracts.packaging_goodsquantity"),
        },
        {
          key: "placegoodsquantity",
          label: this.$t("message.contracts.packaging_placegoodsquantity"),
        },
        {
          key: "action",
          label: "",
        },
      ],
      transport_fields: [
        {
          key: "packaging_transport_number",
          label: this.$t("message.contracts.packaging_transport_number"),
        },
        {
          key: "packaging_transporttypecode",
          label: this.$t("message.contracts.packaging_transporttypecode"),
        },
        {
          key: "packaging_transportcountrycode",
          label: this.$t("message.contracts.packaging_transportcountrycode"),
        },
        {
          key: "packaging_transportleading",
          label: this.$t("message.contracts.packaging_transportleading"),
        },
        {
          key: "action",
          label: "",
        },
      ],
      places_fields: [
        {
          key: "number",
          label: this.$t("message.contracts.packaging_number_pp"),
        },
        {
          key: "packging_placescount",
          label: this.$t("message.contracts.packging_placescount"),
        },
        {
          key: "packaging_placesdescription",
          label: this.$t("message.contracts.packaging_placesdescription"),
        },
        {
          key: "packaging_packagingtypecode",
          label: this.$t("message.contracts.packaging_packagingtypecode"),
        },
        {
          key: "action",
          label: "",
        },
      ],
      packaging_fields: [
        {
          key: "packging_placescount",
          label: this.$t("message.contracts.packging_placescount"),
        },
        {
          key: "packaging_placesdescription",
          label: this.$t("message.contracts.packaging_placesdescription"),
        },
        {
          key: "packaging_packagingtypecode",
          label: this.$t("message.contracts.packaging_packagingtypecode"),
        },
        {
          key: "packaging_partialplacescount",
          label: this.$t("message.contracts.packaging_partialplacescount"),
        },
        {
          key: "action",
          label: "",
        },
      ],
    };
  },
  methods: {
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(
            window.base +
              "/document/getPackingListXML?doc_id=" +
              this.document_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-packing-list");
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-packing-list");
                  });
              });
          });
      }
    },
    /**
     * finds absolute position of the element
     */
    findPos(obj) {
      var curleft = 0;
      var curtop = 0;

      if (obj.offsetParent) {
        do {
          curleft += obj.offsetLeft;
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));

        return { X: curleft, Y: curtop };
      }
    },
    /**
     * replaces data-name of the field with field ID for validation purposes
     */
    field_name_replace(input) {
      let replaces = {
        attis_contract_desc: "contract_description",
        attis_contract_subject: "contract_subject",
      };
      return replaces[input];
    },
    /**
     * Navigates user to the field with error
     */
    go_to_error(error) {
      // switch(error.Subsection){
      // 	case 'Invoice':
      if (error.Subsection == "PackingList") {
        switch (error.Value) {
          case "pkglist_goods.grossweightquantity <> InvoiceGoods.GrossWeightQuantity":
            if (this.packagings[0]) this.edit_packaging(this.packagings[0]);
            setTimeout(() => {
              var element = document.querySelector(
                "#edit_packaging_list #gross_weight_quantity",
              );
              var element_pos = this.findPos(element);
              // element.parentNode.classList.add('error')
              element.focus();
            }, 500);
            // document.querySelector('#modal-document').scrollTo(0, element_pos.Y - 50)
            break;
          case "pkglist_goods.netweightquantity <> InvoiceGoods.NetWeightQuantity":
            if (this.packagings[0]) this.edit_packaging(this.packagings[0]);
            setTimeout(() => {
              var element = document.querySelector(
                "#edit_packaging_list #net_weight_quantity",
              );
              var element_pos = this.findPos(element);
              // element.parentNode.classList.add('error')
              element.focus();
            }, 500);
            break;
          case "sum(pkglist_goods.placegoodsquantity) <> Invoices.PlacesQuantity":
            if (this.packagings[0]) this.edit_packaging(this.packagings[0]);
            setTimeout(() => {
              var element = document.querySelector(
                "#edit_packaging_list #products-table",
              );
              element.classList.add("error");
            }, 500);
            break;
        }
      } else {
        setTimeout(() => {
          this.$root.$emit("process_contract_error", error);
        }, 500);
      }
    },
    delete_list_place(index) {
      this.new_list.places.splice(index, 1);
    },
    edit_new_list_place_save() {
      this.$bvModal.hide("list_places_modal_edit");
    },
    edit_list_place(item, index) {
      this.new_list_place = item;
      this.new_list_place_index = index;
      this.$bvModal.show("list_places_modal_edit");
    },
    edit_place(item, index) {
      this.new_list_place = item;
      this.new_list_place_index = index;
      this.$bvModal.show("list_places_modal_edit");
    },
    add_new_list_place_save() {
      this.new_list.places.push(this.new_list_place);
      this.$bvModal.hide("list_places_modal_add");
    },
    add_list_place() {
      this.new_list_place = {
        packging_placescount: "",
        packaging_placesdescription: "",
        packaging_packagingtypecode: { value: "", display_text: "" },
        packaging_partialplacescount: "",
      };
      this.$bvModal.show("list_places_modal_add");
    },
    display_value_text(value) {
      console.log(value);
      return value.value + " - " + value.display_text;
    },
    save_edit_packaging_list() {
      this.$bvModal.hide("edit_packaging_list");
    },
    edit_packaging(item, index) {
      this.new_list = item;
      this.new_list_index = index;
      this.$bvModal.show("edit_packaging_list");
    },
    delete_packaging(index) {
      this.packagings.splice(index, 1);
    },
    save_create_new_packaging() {
      this.packagings.push(JSON.parse(JSON.stringify(this.new_list)));
      this.$bvModal.hide("create_new_packaging");
    },
    save_new_product() {
      this.new_list.goods.push(this.current_product);
      // this.current_product.packagings.forEach(pack=>{
      //     this.new_list.places.push(pack)
      //     //recheck this part
      // })
      this.$bvModal.hide("add_product");
    },
    save_edit_product() {
      this.$bvModal.hide("edit_product");
    },
    add_product() {
      this.current_product = {
        goodsdescription: "",
        goodsquantity: "",
        placegoodsquantity: "",
        measureunitqualifiername: "",
        grossweightquantity: "",
        netweightquantity: "",
        dimensions: "",
        goodsvolume: "",
        volumeunitqualifiername: "",
        volumeunitqualifiercode: "",
        volumeunitqualifier: { value: "", display_text: "" },

        measureunitqualifier: { value: "", display_text: "" },
        packagings: [],
        goodmarking: "",
        goodscode: "",
      };
      this.$bvModal.show("add_product");
    },
    delete_product(index) {
      this.new_list.goods.splice(index, 1);
    },
    edit_transport_save() {
      this.$bvModal.hide("transport_modal_edit");
    },
    edit_transport(data, index) {
      this.current_transport = data;
      this.current_transport_index = index;
      this.$bvModal.show("transport_modal_edit");
    },
    delete_transport(index) {
      this.new_list.transports.splice(index, 1);
    },
    add_transport_save() {
      this.new_list.transports.push(this.new_product_transport);
      this.new_product_transport = {
        packaging_transport_number: "",
        packaging_transporttypecode: { value: "", display_text: "" },
        packaging_transportcountrycode: { value: "", display_text: "" },
        packaging_transportleading: false,
      };
      this.$bvModal.hide("transport_modal_add");
    },
    add_transport() {
      this.$bvModal.show("transport_modal_add");
    },
    save_packaging_to_product() {
      this.recalculate_product_packaging_places();
      this.$bvModal.hide("product_place_edit_modal");
    },
    delete_product_place(item, index) {
      this.current_product.packagings.splice(index, 1);
    },
    recalculate_product_packaging_places() {
      this.current_product.placegoodsquantity = 0;
      this.current_product.packagings.forEach((pack) => {
        let part = parseInt(pack.packaging_partialplacescount);
        if (!isNaN(part)) this.current_product.placegoodsquantity += part;
        part = parseInt(pack.packging_placescount);
        if (!isNaN(part)) this.current_product.placegoodsquantity += part;
      });
    },
    add_packaging_to_product() {
      console.log("new_product_packaging");
      console.log(this.new_product_packaging);
      this.current_product.packagings.push(this.new_product_packaging);
      this.new_list.places.push(this.new_product_packaging);
      this.recalculate_product_packaging_places();
      this.$bvModal.hide("product_place_add_modal");
    },
    add_product_packaging() {
      this.new_product_packaging = {
        packging_placescount: "",
        packaging_placesdescription: "",
        packaging_packagingtypecode: { value: "", display_text: "" },
        packaging_partialplacescount: "",
      };
      this.$bvModal.show("product_place_add_modal");
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          if (type == "packaging") var_name = "type_packagings";
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (type == "packaging" || type == "transporttype")
              this.$data[var_name].push({
                value: item.value,
                display_text: item.value + " - " + item.display_text,
              });
            else this.$data[var_name].push(item);
          });
          // this.$data[var_name] = response.data
        });
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 100);
    },
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 100);
    },
    fetchPackagings(search, loading) {
      this.getLibrary("packaging", search, 100);
    },
    fetchTransporttypes(search, loading) {
      this.getLibrary("transporttype", search, 100);
    },

    edit_place(item) {},
    edit_product_place(item, index) {
      this.current_product_packaging = item;
      this.current_product_packaging_index = index + 1;
      this.$bvModal.show("product_place_edit_modal");
    },
    edit_product(item) {
      this.current_product = item;
      this.$bvModal.show("edit_product");
    },
    recalculate_total_weights() {
      this.new_list.gross_weight_quantity = this.product_gross_weight;
      this.new_list.net_weight_quantity = this.product_net_weight;
    },
    product_measure_changed(measure) {
      this.current_product.measureunitqualifiername = measure.display_text;
      this.current_product.measureunitqualifiercode = measure.value;
    },
    product_volume_measure_changed(measure) {
      this.current_product.volumeunitqualifiername = measure.display_text;
      this.current_product.volumeunitqualifiercode = measure.value;
    },
    invoice_changed(invoice) {
      this.invoice_id = invoice.DocumentID;
      axios
        .get(window.base + "/document/getFirmbyBin?bin=" + invoice.InvoiceByer)
        .then((response) => {
          this.new_list.consignor = response.data.organizations;
          this.new_list.consignor_name = response.data.organizations.org_name;
        });
      axios
        .get(
          window.base + "/document/getFirmbyBin?bin=" + invoice.InvoiceSeller,
        )
        .then((response) => {
          this.new_list.consignee = response.data.organizations;
          this.new_list.consignee_name = response.data.organizations.org_name;
        });

      //load goods
      this.new_list.invoice.product.forEach((product, i) => {
        var good = {};
        good.goodsdescription = product.GoodsDescription;
        good.goodsquantity = product.GoodsQuantity;
        good.placegoodsquantity = "";
        good.measureunitqualifiername = "";
        good.grossweightquantity = product.GrossWeightQuantity;
        good.netweightquantity = product.NetWeightQuantity;
        good.dimensions = "";
        good.goodsvolume = "";
        good.volumeunitqualifiername = "";
        good.volumeunitqualifiercode = "";
        good.volumeunitqualifier = { value: "", display_text: "" };

        good.measureunitqualifier = this.goods[i].attis_cg_measures;

        try {
          good.volumeunitqualifiername = this.goods[i].attis_cg_measures.value;
          good.measureunitqualifiercode =
            this.goods[i].attis_cg_measures.display_text;
        } catch (e) {}
        good.packagings = [];
        good.goodmarking = product.GoodMarking;
        good.goodscode = product.GoodsCode;
        this.new_list.goods.push(good);
      });

      this.cmrs.forEach((cmr) => {
        this.new_list.transports.push({
          packaging_transport_number: cmr.cmr_track,
          packaging_transporttypecode: { value: "", display_text: "" },
          packaging_transportcountrycode: { value: "", display_text: "" },
          packaging_transportleading: false,
        });
      });

      this.recalculate_total_weights();
    },
    create_packging_list() {
      this.$bvModal.show("create_new_packaging");
    },
    load() {
      axios
        .get(
          window.base + "/document/getPackingList/?doc_id=" + this.document_id,
        )
        .then((response) => {
          this.packagings = response.data.map((item) => {
            if (item.invoice && item.invoice.DocumentID) {
              item.invoice.value = item.invoice.DocumentID;
              item.invoice.display_text =
                this.$t(
                  "message.contracts.documents_packaging_list_invoce_by_contract",
                ) +
                this.$route.params.id +
                "(" +
                item.invoice.DocumentNumber +
                ")";
            }
            if (item.consignor && item.consignor.org_name)
              item.consignor_name = item.consignor.org_name;
            if (item.consignee && item.consignee.org_name)
              item.consignee_name = item.consignee.org_name;

            if (item.transports) {
              item.transports.map((transp) => {
                if (
                  transp.packaging_transportcountrycode &&
                  transp.packaging_transportcountrycode.value
                )
                  axios
                    .get(
                      window.base +
                        "/library/country/?code=" +
                        transp.packaging_transportcountrycode.value +
                        "&lang=" +
                        this.$i18n.locale,
                    )
                    .then((r) => {
                      transp.packaging_transportcountrycode = r.data[0];
                    });
                if (
                  transp.packaging_transporttypecode &&
                  transp.packaging_transporttypecode.value
                )
                  axios
                    .get(
                      window.base +
                        "/library/transporttype/?code=" +
                        transp.packaging_transporttypecode.value +
                        "&lang=" +
                        this.$i18n.locale,
                    )
                    .then((r) => {
                      transp.packaging_transporttypecode = r.data[0];
                    });
                return transp;
              });
            }

            if (item.places) {
              item.places.map((pl) => {
                console.log(pl.packaging_packagingtypecode);
                if (
                  pl.packaging_packagingtypecode &&
                  pl.packaging_packagingtypecode.value
                )
                  pl.packaging_packagingtypecode =
                    this.type_packagings[
                      this.type_packagings.findIndex(
                        (i) =>
                          i.value ==
                          pl.packaging_packagingtypecode.value.trim(),
                      )
                    ];
                // axios.get(window.base + '/library/packaging/?code='+pl.packaging_packagingtypecode.value+'&lang='+this.$i18n.locale).then(r=>{
                //     pl.packaging_packagingtypecode = r.data[0]
                // })
                return pl;
              });
            }

            if (item.goods) {
              item.goods.map((g1) => {
                if (g1.packagings) {
                  g1.packagings.map((p1) => {
                    if (p1.packaging_packagingtypecode) {
                      if (p1.packaging_packagingtypecode.value) {
                        p1.packaging_packagingtypecode =
                          this.type_packagings[
                            this.type_packagings.findIndex(
                              (i) =>
                                i.value ==
                                p1.packaging_packagingtypecode.value.trim(),
                            )
                          ];
                        console.log("packaging types");
                        console.log(p1.packaging_packagingtypecode);
                      }
                    }
                  });
                }
              });
            }

            return item;
          });
        });
    },
    fetchInvoices() {
      axios
        .get(
          window.base + "/document?attis_contract_id=" + this.$route.params.id,
        )
        .then((response) => {
          for (var i in response.data) {
            var item = response.data[i];
            if (item.DocType == "Инвойс") {
              axios
                .get(
                  window.base +
                    "/Document/LoadInvoice/?doc_id=" +
                    item.DocumentID,
                )
                .then((response) => {
                  response.data.value = response.data.DocumentID;
                  response.data.display_text =
                    this.$t(
                      "message.contracts.documents_packaging_list_invoce_by_contract",
                    ) +
                    this.$route.params.id +
                    "(" +
                    response.data.DocumentNumber +
                    ")";
                  this.invoices.push(response.data);
                });
            }
            if (item.DocType == "CMR") {
              axios
                .get(
                  window.base + "/Document/LoadCMR/?doc_id=" + item.DocumentID,
                )
                .then((response) => {
                  // response.data.value = response.data.DocumentID
                  // response.data.display_text = this.$t('message.contracts.documents_packaging_list_invoce_by_contract')+this.$route.params.id + '('+response.data.DocumentNumber+')'
                  this.cmrs.push(response.data);
                });
            }
          }
          setTimeout(() => {
            if (this.invoices.length == 1) {
              this.new_list.invoice = this.invoices[0];
              this.invoice_changed(this.invoices[0]);
            }
          }, 500);
        });
    },
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-packing-list");
    },
    signDocument() {
      this.loading = true;
      axios
        .get(
          window.base +
            "/document/getPackingListXML?doc_id=" +
            this.document_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      let name = response.data.cert_name;
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature", value);
                      fd.append("signature_name", name);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide(
                            "modal-select-ecp-type-packing-list",
                          );
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide(
                            "modal-select-ecp-type-packing-list",
                          );
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    saveDocument(validate) {
      this.packagings.map((pack) => {
        pack.transports.map((tran) => {
          tran.packaging_transportleading = Number(
            tran.packaging_transportleading,
          );
          return tran;
        });
        return pack;
      });
      if (this.is_new) {
        axios
          .post(
            window.base +
              "/document/AddPackingList?attis_contract_id=" +
              this.contract_details.attis_contract_id +
              "&doc_id=" +
              this.invoice_id,
            this.packagings,
          )
          .then((response) => {
            if (response.data.status == "ok") {
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.packaging-created"),
                timeout: 5000,
              }).show();
              if (validate && response.data.doc_id !== null) {
                //this.document_id = response.data.doc_id;
                this.$root.$emit("unshow-loading");
                this.buttons_loading = false;
                setTimeout(() => {
                  this.$root.$emit("save-and-validate", response.data.doc_id);
                  //this.current_tab = 0
                  setTimeout(() => {
                    //var element = document.querySelector('#ap_main_reg_date')
                    //var element_pos = this.findPos(element)
                    //element.parentNode.classList.add('error')
                    //element.focus()
                    if (document.querySelector("#modal-document") != null)
                      document.querySelector("#modal-document").scrollTo(0, 0);
                    if (document.querySelector("#modal-document-new") != null)
                      document
                        .querySelector("#modal-document-new")
                        .scrollTo(0, 0);
                  }, 500);
                }, 500);
              } else {
                this.$root.$emit("loadDocuments", { category: "all" });
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            } else {
              console.info("else case");
              new Noty({
                theme: "light",
                type: "error",
                text:
                  this.$root.$t("message.message.packaging-not-created") +
                  " (" +
                  response.data +
                  ")",
                timeout: 5000,
              }).show();
              if (window.dev_mode) {
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            }
          })
          .catch((e) => {
            console.log(e);
            new Noty({
              theme: "light",
              type: "error",
              text: t1,
              timeout: 5000,
            }).show();
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
          });
      } else {
        axios
          .post(
            window.base +
              "/document/UpdatePackingList?list_id=" +
              this.document_id,
            this.packagings,
          )
          .then((response) => {
            if (response.data.status == "ok") {
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.packaging-created"),
                timeout: 5000,
              }).show();
              if (validate && response.data.doc_id !== null) {
                //this.document_id = response.data.doc_id;
                this.$root.$emit("unshow-loading");
                this.buttons_loading = false;
                setTimeout(() => {
                  this.$root.$emit("save-and-validate", response.data.doc_id);
                  //this.current_tab = 0
                  setTimeout(() => {
                    //var element = document.querySelector('#ap_main_reg_date')
                    //var element_pos = this.findPos(element)
                    //element.parentNode.classList.add('error')
                    //element.focus()
                    if (document.querySelector("#modal-document") != null)
                      document.querySelector("#modal-document").scrollTo(0, 0);
                    if (document.querySelector("#modal-document-new") != null)
                      document
                        .querySelector("#modal-document-new")
                        .scrollTo(0, 0);
                  }, 500);
                }, 500);
              } else {
                this.$root.$emit("loadDocuments", { category: "all" });
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            } else {
              console.info("else case");
              new Noty({
                theme: "light",
                type: "error",
                text:
                  this.$root.$t("message.message.packaging-not-created") +
                  " (" +
                  response.data +
                  ")",
                timeout: 5000,
              }).show();
              if (window.dev_mode) {
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            }
          })
          .catch((e) => {
            console.log(e);
            new Noty({
              theme: "light",
              type: "error",
              text: t1,
              timeout: 5000,
            }).show();
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
          });
      }
    },
    importGoodsExcel(event, index) {
      if (typeof event.target.files[0] !== "undefined") {
        var fd = new FormData();
        this.files_loading = true;
        fd.append("Files[0]", event.target.files[0]);
        axios
          .post(window.base + "/document/import_excel_goods?type=packing", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.files_loading = false;
            if (response.data !== "error") {
              response.data.forEach((good) => {
                var tmp_good = {};
                //tmp_good.good_guid = good.cgood_guid
                tmp_good = good;
                (tmp_good.good_no = this.new_list.goods + 1),
                  this.new_list.goods.push(tmp_good);
              });
            }
            //this.hideAddProduct();
          });
      }
    },
  },
  mounted() {
    this.fetchInvoices();
    this.fetchMeasures("");
    this.fetchPackagings("");
    this.fetchTransporttypes("");
    this.fetchCountries("");
    this.$root.$on("go_to_packaging_error", (error_data) => {
      this.go_to_error(error_data);
    });
    if (this.document_id == "new") {
    } else {
      this.load();
    }
    this.new_list.delivery_terms =
      this.contract_details.attis_contract_delivery_term;
  },
  computed: {
    is_field_readonly() {
      if (
        typeof this.packagings[0] !== "undefined" &&
        this.packagings[0].IsSigned
      )
        return true;
      return false;
    },
    new_list_place_number() {
      if (typeof this.new_list.places !== "undefined")
        return this.new_list.places.length + 1;
      else return 0;
    },
    new_product_transport_number() {
      if (typeof this.new_list.transports !== "undefined")
        return this.new_list.transports.length + 1;
      else return 0;
    },
    new_product_packaging_number() {
      if (typeof this.current_product.packagings !== "undefined")
        return this.current_product.packagings.length + 1;
      else return 0;
    },
    product_gross_weight() {
      var sum = 0;
      this.new_list.goods.forEach((item) => {
        sum += parseFloat(item.grossweightquantity);
      });
      return sum;
    },
    product_net_weight() {
      var sum = 0;
      this.new_list.goods.forEach((item) => {
        sum += parseFloat(item.netweightquantity);
      });
      return sum;
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  watch: {},
  validations: {
    new_list: {
      invoice: {
        required,
      },
      gross_weight_quantity: {
        required,
      },
      net_weight_quantity: {
        required,
      },
    },
  },
};
</script>
<style>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 1140px !important;
  }
}
@media (min-width: 992px) {
  .modal-lg {
    max-width: 800px !important;
  }
}
@media (min-width: 576px) {
  .modal-sm {
    max-width: 300px !important;
  }
}
#products-table.error {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>
